import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export function DonationPolling() {
  return (
    <div className="min-h-screen bg-stone-light flex items-center justify-center px-4">
      <Card className="border-stone max-w-md w-full">
        <CardContent className="p-8 text-center">
          <Loader2 className="w-12 h-12 animate-spin text-sage mx-auto mb-4" />
          <h2 className="font-serif text-2xl font-semibold text-stone-dark mb-2" data-testid="donation-processing">
            Processing Your Donation
          </h2>
          <p className="text-stone-dark/60">Please wait while we confirm your payment...</p>
        </CardContent>
      </Card>
    </div>
  );
}

export function DonationSuccess({ paymentDetails, user, onReset }) {
  return (
    <div className="min-h-screen bg-stone-light flex items-center justify-center px-4">
      <Card className="border-stone max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="font-serif text-2xl font-semibold text-stone-dark mb-2" data-testid="donation-success">
            Thank You!
          </h2>
          <p className="text-stone-dark/60 mb-4">
            Your donation of <span className="font-semibold text-sage">${paymentDetails?.amount?.toFixed(2)}</span> has been received.
          </p>
          <p className="text-sm text-stone-dark/50 mb-6">Your generosity makes a difference.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/donate">
              <Button
                variant="outline"
                className="rounded-full border-sage text-sage"
                onClick={onReset}
                data-testid="donate-again-btn"
              >
                Donate Again
              </Button>
            </Link>
            <Link to={user ? "/dashboard" : "/"}>
              <Button className="bg-sage hover:bg-sage-dark text-white rounded-full" data-testid="back-home-btn">
                {user ? "Back to Dashboard" : "Back to Home"}
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export function DonationCancelled({ onReset }) {
  return (
    <div className="min-h-screen bg-stone-light flex items-center justify-center px-4">
      <Card className="border-stone max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-stone/30 flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-stone-dark/50" />
          </div>
          <h2 className="font-serif text-2xl font-semibold text-stone-dark mb-2" data-testid="donation-cancelled">
            Donation Cancelled
          </h2>
          <p className="text-stone-dark/60 mb-6">No worries! You can donate anytime.</p>
          <Link to="/donate">
            <Button
              className="bg-sage hover:bg-sage-dark text-white rounded-full"
              onClick={onReset}
              data-testid="try-again-btn"
            >
              Try Again
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}

export function DonationFailed({ onReset }) {
  return (
    <div className="min-h-screen bg-stone-light flex items-center justify-center px-4">
      <Card className="border-stone max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="font-serif text-2xl font-semibold text-stone-dark mb-2">Payment Issue</h2>
          <p className="text-stone-dark/60 mb-6">We couldn't confirm your payment. Please check your email for a receipt or try again.</p>
          <Link to="/donate">
            <Button
              className="bg-sage hover:bg-sage-dark text-white rounded-full"
              onClick={onReset}
            >
              Try Again
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
